import {gsap} from "gsap";
import {$dom} from '../../../helpers/dom';
import {$style} from '../../../helpers/style';
import variables from '../../../variables';
import Scrollbar from 'smooth-scrollbar';
import is from 'is_js';

const {
	getAll,
	get,
	each,
	attr,
	addClass,
	removeClass
} = $dom;

const {
	offset
} = $style;

export default function statisticsIntroChart() {

	const
		rectAttr = 'data-intro-chart-rect',
		rectSelector = `[${rectAttr}]`,
		pointAttr = 'data-intro-chart-point',
		pointSelector = `[${pointAttr}]`,
		sectionSelector = '.js-statistics-intro',
		curtainSelector = '.js-statistics-intro-curtain',
		svgLineSelector = '.js-statistics-intro-svg-line',
		pointContentSelector = '.js-statistics-intro-point-content',
		drawEndClassName = 'is-draw-end',
		edgedPointClassName = 'is-edged',
		duration = variables.gsapDefaultDuration * 3,
		pointYInitOffset = 150,
		rectsParentModifier = variables.windowWidth > variables.breakpoints.sm ? '--desktop' : '--mobile'
	;

	let tl;

	const
		getBoundPoint = rect => get(`[${pointAttr}="${attr(rect, rectAttr)}"]`),
		setPointsPosition = () => {
			const
				rects = getAll(rectSelector, svgLineSelector + rectsParentModifier),
				mainScroll = Scrollbar.get(variables.dom.mainScroll)
			;

			each(rects, rect => {
				const rectOffset = offset(rect);

				gsap.set(getBoundPoint(rect), {
					top: rectOffset.top + (is.not.undefined(mainScroll) ? mainScroll.offset.y : 0),
					left: rectOffset.left
				})
			});
		},
		init = () => {
			tl = gsap.timeline({repeat: false});

			const
				curtain = get(curtainSelector)
			;
			const reversedRects = getAll(rectSelector, svgLineSelector + rectsParentModifier).reverse();

			each(reversedRects, rect => {
				const
					point = getBoundPoint(rect),
					content = get(pointContentSelector, point)
				;

				tl
					.to(curtain, {
						width: offset(rect).left,
						ease: 'sine.out',
						duration
					})
					.from(point, {
						y: -(pointYInitOffset - point.offsetHeight),
						autoAlpha: 0,
						ease: 'sine.out',
						duration: duration / 2
					})
					.from(content, {
						xPercent: 10,
						autoAlpha: 0,
						ease: 'sine.out',
						duration: duration / 2,
						onComplete() {
							let cmnW = offset(content).left + content.offsetWidth;
							let ww = variables.windowWidth;

							if (cmnW > ww) {
								gsap.to(content, {
									marginLeft: - (content.offsetWidth),
									ease: 'sine.out',
									duration,
									onStart() {
										addClass(point, edgedPointClassName)
									}
								})
							}
						}
					})
			});

			tl.to(curtain, {
				width: 0,
				ease: 'sine.out',
				duration,
				onComplete() {
					addClass(get(sectionSelector), drawEndClassName)
				}
			});

		},
		destroy = () => {
			tl.kill();
			tl = null;
			gsap.set(pointSelector, {clearProps: 'top,left,y,opacity,visibility'});
			gsap.set(pointContentSelector, {clearProps: 'marginLeft,xPercent,opacity,visibility'});
			gsap.set(curtainSelector, {clearProps: 'width'});
			removeClass(sectionSelector, drawEndClassName);
			removeClass(pointSelector, edgedPointClassName);
		}
	;

	return {init, destroy, setPointsPosition}
}
